import { render, staticRenderFns } from "./iframePage.vue?vue&type=template&id=7558b5e9&scoped=true&"
import script from "./iframePage.vue?vue&type=script&lang=js&"
export * from "./iframePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7558b5e9",
  null
  
)

export default component.exports